<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2b"><a id="page_7">PREFACE</a></h2><a id="page_7">
<p class="noindent">This is a continuation of the study of the Tondu Valleys, completing each of the railway branches started in the first volume dealing with the Llynfi Valley. Though the correct spelling of Llynfi is with an F, the name became anglicised to Llynvi in the course of time as Welsh single F is pronounced V and it is spelt as such by the railway thereafter. Additionally, we present a photographic record of Enthusiast Specials, Main Line Diversions and two pictorial Chronologies taken on 3 May 1958 when services on the Ogmore Valley were withdrawn and on 7 July 1962, mainly featuring the photographs of Sid Rickard, the well-known South Wales Valleys photographer, who travelled on the Tondu to Porthcawl service that day to record the working.</p>
<p class="indent">The first volume, dealing with the Llynfi Valley, also provides full information on the South Wales coalfield as it existed in the whole of the Tondu Valleys as well as full details of the working throughout the Tondu Valleys from Tondu Depot.</p>
<p class="noindent">Note: In line with standard GWR practice, all trains running from Paddington were described as Down trains and all to Paddington as Up. This also applied to GWR-operated South Wales Valleys services. This varied from the pre-Grouping South Wales companies which (equally logically) described those trains going up the Valleys as Up and coming back down as Down. As the Tondu Valleys were operated by the GWR from an early date, trains proceeding from Bridgend to Cymmer Afan were Down services.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Preface.vue?077b2994